import React, { Component } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from "gatsby-image"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "@emotion/styled"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronLeft, faChevronRight} from'@fortawesome/free-solid-svg-icons'

const CarCaseResult = styled.div`
background: #0e1f38;
    color: #fff;
    padding: 30px;
    margin-bottom: 60px;
`
const BorderBox = styled.div`
border: 1px solid #1a3866;
    padding: 20px;
    position: relative;
`
const HeaderSectionTextCenter = styled.div`
margin: 0 0 30px;
position: relative;
text-align: center;

h4{
    font-size: 30px;
    color: #fff;
    margin-bottom: 15px;
    letter-spacing: 2px;
    font-family: "Playfair Display";
    font-weight: 500;
    line-height: 1.2;
}
`
const PracticeHeader = styled.div`

`
const SliderWrapper = styled.div`
position: relative;
.anticon{position: absolute; top: 50%; transform: translateY(-50%)}
.anticon-right-circle{right: 0;}
`
const RedBackground = styled.div`
text-align: center;
    background: #b6212a;
    padding: 29px 10px;

    p{
        font-family: 'Playfair Display';
        font-weight: 400;
        font-size: 35px;
        margin-bottom: 20px;
    }
`
const SliderStyled = styled(Slider)`
margin-bottom: 30px;
display: block;


.slick-prev, .slick-next{
    font-size: 0;
    line-height: 0;
    position: absolute;
    display: block;
    transform: translateY(-50%);
    cursor: pointer;
    border: none;
}
.slick-next{
    border-left: 1px solid #fff;
}
.number_1{
    text-align: center;
}
.number_1 span{
    background: #b6212a;
    color: #fff;
    display: inline-block;
    padding: 8px 20px 9px;
    bottom: 16px;
    border-left: 1px solid #fff;
    border-right: 1px solid #fff;
}
`
const SliderStyled2 = styled(SliderStyled)`
text-align: center;
    position: absolute;
    width: 100px;
    left: 50%;
    bottom: -34px;
    transform: translateX(-50%);
    margin-bottom: 0;
`

const FontAwesomeIconStyled = styled(FontAwesomeIcon)`
display: block;  
width: 44px !important; 
height: 36px;
color:  #d8868b;
background-color: #b6212a;
padding: 10px 11px;
top: 18px;

:hover{
    color: #fff;
    background-color: #b6212a;
}

`
function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FontAwesomeIconStyled
        icon={faChevronRight}
        className={className}
        onClick={onClick}
      />
    );
  }
  
  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <FontAwesomeIconStyled
      icon={faChevronLeft}
        className={className}
        onClick={onClick}
      />
    );
  }
export default class CaseResultsSlider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          nav1: null,
          nav2: null
        };
      }
    
      componentDidMount() {
        this.setState({
          nav1: this.slider1,
          nav2: this.slider2
        });
      }
    render(){
        const settings = {
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false
          };
          const settings2 = {
              asNavFor: '',
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            fade: true,
            arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
          };
    return(
<StaticQuery
          query={graphql`
          {
            file(relativePath: {eq: "header-bottom-line.png"}) {
              childImageSharp {
                fixed(width: 56, height: 14) {
                    ...GatsbyImageSharpFixed_withWebp_noBase64
                }
              }
            }
          }`}
render={props => (
    <CarCaseResult>
<BorderBox>
                        <HeaderSectionTextCenter>
                          <h4>Case Results</h4>
                          <PracticeHeader>
                        <Img fixed={props.file.childImageSharp.fixed} />
                          </PracticeHeader>
                        </HeaderSectionTextCenter>
                        <SliderWrapper>
                        <SliderStyled {...settings} asNavFor={this.state.nav2} ref={slider => (this.slider1 = slider)}>
                          <RedBackground>
                            <p>$225,000</p>
                            <span>SEPTA BUS ACCIDENT</span>
                          </RedBackground>
                          <RedBackground>
                            <p>$100,000</p>
                            <span>SIDESWIPED BY A DRUNK DRIVER</span>
                          </RedBackground>
                          <RedBackground>
                            <p>$1,000,000</p>
                            <span>SLIP AND FALL ON ICE</span>
                          </RedBackground>
                          <RedBackground>
                            <p>$380,000</p>
                            <span>DELIVERY TRUCK ACCIDENT</span>
                          </RedBackground>
                          <RedBackground>
                            <p>$1,100,000</p>
                            <span>SUFFERED HEAD INJURY</span>
                          </RedBackground>
                        </SliderStyled>
                        </SliderWrapper>
                        <SliderWrapper>
                        <SliderStyled2 {...settings2} asNavFor={this.state.nav1}
          ref={slider => (this.slider2 = slider)}>
                          <div className="number_1">
                            <span>1 / 5</span>
                          </div>
                          <div className="number_1">
                            <span>2 / 5</span>
                          </div>
                          <div className="number_1">
                            <span>3 / 5</span>
                          </div>
                          <div className="number_1">
                            <span>4 / 5</span>
                          </div>
                          <div className="number_1">
                            <span>5 / 5</span>
                          </div>
                        </SliderStyled2>
                        </SliderWrapper>
                      </BorderBox>
                      </CarCaseResult>
                      )
                    }
                    />
    );
    }
}